// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7627ff7f","640":"574d1ebe"}[chunkId] + ".chunk.js";
};